export class DeliveryStaticData {
    public static readonly LINK_TO_DELIVERY_PAGE: string = 'https://helthjem.no/faq';
    public static readonly DELIVERY_PRICE: number = 0;
    public static readonly DELIVERY_TIME_FOR_TRANSPORTER: string = '1-3';
}
